import { Store } from 'vuex';
import { GlobalState } from 'frontend/types';

interface StateWithGlobals {
  globals: GlobalState;
}

export function initHotjar(store: Store<StateWithGlobals>) {
  if (
    store.state.globals.privacy_properties?.third_party_cookies_disabled ||
    store.state.globals.privacy_properties?.under_17 ||
    !store.state.globals.feature_switches?.enable_hotjar
  ) {
    return;
  }

  // This is the hotjar script with juuust enough typescript to get rid of errors
  // tslint:disable
  (function (h: any, o: Document, t: string, j: string, a: any = undefined, r: any = undefined) {
    h.hj =
      h.hj ||
      function () {
        (h.hj.q = h.hj.q || []).push(arguments);
      };
    h._hjSettings = { hjid: 1792270, hjsv: 6 };
    a = o.getElementsByTagName('head')[0];
    r = o.createElement('script');
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window as any, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
  // tslint:enable
}
